<template>
  <v-card>
    <v-card-title class="headline py-2">
      {{editMode?'Редактировать':'Добавить'}} папку
      <v-spacer></v-spacer>
      <v-btn icon class="mx-0" @click="$emit('close-dialog')">
        <v-icon>close</v-icon>
      </v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <dantser-tree
        label="Родительская папка"
        :source="foldersTree"
        ref="parentFolder"
        :field="true"
        :selectMode="1"
        @node-dblclick="setParent($event)"
      >
      </dantser-tree>
      
      <v-text-field v-model="folder.name" label="Название"></v-text-field>
      <div class="mb-3">
        <label class="v-label theme--light" style="font-size: 13px">Описание</label>
        <dantser-editor v-model="folder.description" :init="config" :api-key="apiKey"></dantser-editor>
      </div>
      
      <template v-if="type==='property'">
        <p>Доступ для модулей</p>
        <v-data-table :headers="headers" :items="modules" hide-actions no-data-text="Данные отсутствуют">
          <template slot="items" slot-scope="{item, index}">
            <td>{{item.name}}</td>
            <td>
              <v-checkbox v-model="item.show" class="justify-center" color="primary" hide-details></v-checkbox>
            </td>
            <td>
              <v-checkbox v-model="item.open" class="justify-center" color="primary" hide-details></v-checkbox>
            </td>
          </template>
        </v-data-table>
      </template>
      
      
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions class="pa-3">
      <v-btn color="success" @click="submit" :disabled="status.btnDisabled">Сохранить</v-btn>
      <span :class="status.className" class="ml-2">{{status.text}}</span>
    </v-card-actions>
  </v-card>
</template>

<script>
  import {mapState} from 'vuex'
  import all_modules from '../../../available_modules'
  
  export default {
    name : "FolderForm",
    
    props:{
      data:{
        type: Object,
        required: false,
        default: () => { return {
          name: '',
          description: '',
          parent_id: null,
        }}
      },
      parent_id:{
        type: Number,
        required: false,
        default: null
      },
      editMode: {
        type: Boolean,
        required: false,
        default: false
      },
      type: {
        type: String,
        required: false,
        default: 'object'
      }
    },
  
    computed:{
      ...mapState('analytics', {
        config: state => state.editorBaseConfig,
        apiKey: state => state.editorApiKey,
      }),
    },
    
    created(){
      this.folder = JSON.parse(JSON.stringify(this.data))
      if(!this.editMode) this.folder.parent_id = this.parent_id
      if(this.type === 'property'){
        for(let id in all_modules){
          this.modules.push({
            id: id,
            name: all_modules[id],
            show: false,
            open: false
          })
        }
        this.$set(this.folder, 'modules', [])
      }
      this.getFolders()
      if(this.editMode && this.type!=='form'){
        this.getFolder()
      }
    },
    
    data(){
      return {
        status:{
          btnDisabled: false,
          text: '',
          className:'success--text darken-1'
        },
        folder:{},
        foldersTree: [],
        modules:[],
        headers: [
          { text: 'Модуль', align: 'left', sortable: false },
          { text: 'Доступно', align: 'center', sortable: false, width: 40 },
          { text: 'Открыть папку', align: 'center', sortable: false, width: 40 },
        ],
      }
    },
    
    methods:{
      getFolders(){
        let id = this.editMode ? this.folder.id : 0

        this.$store.dispatch('analytics/constructor/getFoldersTree', {id, type: this.type}).then( response => {
          response.unshift({ id: 0, name: 'Не выбрано', icon: 'mdi mdi-square' })
          this.foldersTree = response
          this.$nextTick(function(){
            if(this.folder.parent_id!=null){
              this.$refs['parentFolder'].setSelected(this.folder.parent_id)
            } else {
              this.$refs['parentFolder'].setSelected(0)
            }
          })
        })
      },
      
      getFolder(){
        this.$store.dispatch('analytics/constructor/getFolder', {id: this.folder.id, type: this.type}).then( folder => {
          this.folder.description = folder.description
          
          if(this.type==='property'){
            folder.modules.map( item => {
              let module = this.modules.find( el => el.id === item.id)
              if(module) {
                module.show = true
                module.open = item.open
              }
            })
          }
        })
      },
      
      setParent(eventData){
        this.folder.parent_id = eventData.id
      },
      
      submit(){
        this.status={ btnDisabled: true, text: 'Сохранение', className:'secondary--text lighten-1' }
  
        if(this.type==='property'){
          this.folder.modules = this.modules.filter( el => el.show===true )
        }
        
        if(this.editMode){
          this.$store.dispatch('analytics/constructor/updateFolder', {data: this.folder, type: this.type} ).then( response => {
            this.status={ btnDisabled: false, text: 'Сохранено', className:'success--text darken-1' }
            this.$emit('close-dialog')
          }).catch( error => {
            this.status={ btnDisabled: false, text: 'Ошибка', className:'error--text darken-1' }
          })
        } else {
          this.$store.dispatch('analytics/constructor/createFolder', {data: this.folder, type: this.type} ).then( response => {
            this.status={ btnDisabled: false, text: 'Сохранено', className:'success--text darken-1' }
            this.$emit('close-dialog')
          }).catch( error => {
            this.status={ btnDisabled: false, text: 'Ошибка', className:'error--text darken-1' }
          })
        }
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/apps/analytics/components/Constructor/Forms/FolderForm.vue